import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IMainPage,
  IObjects,
  IPrograms,
  TError,
  TErrorMainPage,
} from "./types/main-page-interface";
import { fetchDictionaries, fetchProductAlias } from "./action/fetch-main-page";

const initialState: IMainPage = {
  isLoadingDictionaries: false,
  errorDictionaries: [],
  productId: "",
  programs: [],
  regions: [],
  sellerId: "",
  doNotShowRegion: false,
  productAlias: {
    isLoadingProductAlias: false,
    errorProductAlias: [],
    ProductAlias: "",
    ProductPrintName: "",
  },
};

export const MainPageSlice = createSlice({
  name: "MainPageSlice",
  initialState,
  reducers: {
    resetDictionaries: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDictionaries.pending, (state) => {
        state.isLoadingDictionaries = true;
      })
      .addCase(
        fetchDictionaries.fulfilled,
        (
          state,
          action: PayloadAction<{
            productId: string;
            sellerId: string;
            regions: IObjects[];
            programs: IPrograms[];
            doNotShowRegion: boolean;
          }>
        ) => {
          state.regions = action.payload.regions;
          state.programs = action.payload.programs;
          state.sellerId = action.payload.sellerId;
          state.productId = action.payload.productId;
          state.doNotShowRegion = action.payload.doNotShowRegion;
          state.isLoadingDictionaries = false;
          state.errorDictionaries = [];
        }
      )
      .addCase(fetchDictionaries.rejected, (state, action) => {
        state.doNotShowRegion = initialState.doNotShowRegion;
        state.regions = initialState.regions;
        state.programs = initialState.programs;
        state.sellerId = initialState.sellerId;
        state.productId = initialState.productId;
        state.isLoadingDictionaries = false;
        state.errorDictionaries = action.payload as TErrorMainPage;
      })
      .addCase(fetchProductAlias.pending, (state) => {
        state.productAlias.isLoadingProductAlias = true;
      })
      .addCase(
        fetchProductAlias.fulfilled,
        (
          state,
          action: PayloadAction<{
            ProductAlias: string;
            ProductPrintName: string;
          }>
        ) => {
          state.productAlias.ProductAlias = action.payload.ProductAlias;
          state.productAlias.ProductPrintName = action.payload.ProductPrintName;
          state.productAlias.isLoadingProductAlias = false;
          state.productAlias.errorProductAlias = [];
        }
      )
      .addCase(fetchProductAlias.rejected, (state, action) => {
        state.productAlias.ProductAlias =
          initialState.productAlias.ProductAlias;
        state.productAlias.ProductPrintName =
          initialState.productAlias.ProductPrintName;
        state.productAlias.isLoadingProductAlias = false;
        state.productAlias.errorProductAlias = action.payload as TError;
      });
  },
});

export const { resetDictionaries } = MainPageSlice.actions;
export default MainPageSlice.reducer;
